import { Injector, inject, Service } from '@angular/core';
import { environment } from '@env/environment';
import { from, map, Observable, of } from 'rxjs';

import { __ } from '../functions/object.functions';
import { Tenant } from '../models/classes/Tenant';
import { ITenantService } from './itenant.service';

@Service({ autoProvided: false })
export class ApiUrlService {
  private injector = inject(Injector);

  private _tenantService: ITenantService | null = null;

  private get tenantService(): ITenantService {
    if (!this._tenantService) {
      this._tenantService = this.injector.get(ITenantService);
    }
    return this._tenantService;
  }

  getTenant(): Tenant | null {
    return this.tenantService.getTenant();
  }

  getApiUrl(): string {
    if (environment.environmentName === 'DEV') {
      return environment.serverUrl;
    }

    const tenant = this.getTenant();

    if (!__.IsNullOrUndefined(tenant)) {
      return tenant.apiUrl;
    }

    throw new Error(`[API URL SERVICE] No tenant specified`);
  }

  getApiUrl$(): Observable<string> {
    if (environment.environmentName === 'DEV') {
      return of(environment.serverUrl);
    }

    const tenant = this.getTenant();
    if (!__.IsNullOrUndefined(tenant)) {
      return of(tenant.apiUrl);
    }

    return from(this.tenantService.loadTenant()).pipe(map((tenant) => tenant.apiUrl));
  }

  getCdnUrl(): string {
    if (environment.environmentName === 'DEV') {
      return environment.serverUrlCDN;
    }

    const tenant = this.getTenant();

    if (!__.IsNullOrUndefined(tenant)) {
      return tenant.cdnUrl;
    }

    throw new Error(`[API URL SERVICE] No tenant specified`);
  }
}
